import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Dialog, Typography, InputBase, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';

import Select from 'react-select';
import { useSnackbar } from 'notistack';

import ToastStr from '../request/toastStr';
import { COLORS } from '../shared/Theme';
import { useTranslation } from 'react-i18next';
import { getSavedLanguage } from '../locales';

const useStyles = makeStyles((theme) => ({
	title: {
		textAlign: 'center',
		display: 'inline-block',
		alignContent: 'center',
		padding: 0,
		'& h2': {
			color: `${COLORS.WATER_BLUE}`,
			fontFamily: 'NanumB',
			fontSize: '3vh',
			'& svg': {
				margin: 'auto',
				marginRight: '2vw',
			},
		},
	},
	icon: {
		textAlign: 'center',
		paddingBottom: 0,
		[theme.breakpoints.up('md')]: {
			marginBottom: '3vh',
		},
	},
	content: {
		textAlign: 'center',
		marginTop: '4vh',
		marginBottom: '2.5vh',
		overflowY: 'visible',
		padding: 0,
		'& #contentTitle': {
			color: `${COLORS.CHARCOAL_GREY}`,
			fontFamily: 'NanumB',
			fontWeight: 'bold',
			marginBottom: '1vh',
		},
	},
	action: {
		padding: 0,
		'& button': {
			fontSize: '16px',
			color: `${COLORS.BROWNISH_GREY}`,
		},
	},

	underline: {
		// borderBottom: "0px solid red !important",
		'&:hover': {
			borderBottom: '0px solid rgba(0,0,0,0)',
		},
		backgroundColor: '#ffffff',
	},

	desc: {
		fontSize: '2.3vw',
		[theme.breakpoints.up('md')]: {
			...theme.typography.body1,
		},
	},

	orderComplete: {
		textAlign: 'center',
		marginRight: 3,
		color: `${COLORS.WATER_BLUE}`,
		fontWeight: 'bold',
		fontSize: '5vw',
		[theme.breakpoints.up('md')]: {
			fontSize: '28px',
		},
	},

	buttonText: {
		fontSize: '16px',
	},

	warnText: {
		color: 'red',
		fontWeight: 'bold',
		fontSize: '4vw',
		[theme.breakpoints.up('md')]: {
			fontSize: '30px',
		},
	},
	// --- Existing styles above ---
	processRoot: {
		padding: 0,
	},
	processHeader: {
		backgroundColor: COLORS.WATER_BLUE,
		color: COLORS.WHITE,
		padding: '12px 16px',
		textAlign: 'center',
	},
	processTitle: {
		fontFamily: 'NanumB',
		fontWeight: 700,
		fontSize: 20,
	},
	processBody: {
		display: 'flex',
		flexDirection: 'column',
		padding: 12,
		gap: 20,
	},
	infoBox: {
		display: 'flex',
		flexDirection: 'column',
		gap: 10,
		border: '1px solid #E5E5EA',
		borderRadius: 8,
		background: '#F7F8FB',
		padding: 12,
	},
	infoRow: {
		display: 'flex',
		flexDirection: 'column',
		gap: 5,
	},
	infoLabel: {
		color: '#666666',
		fontSize: 14,
	},
	infoValue: {
		color: '#333333',
		fontWeight: 700,
		fontSize: 16,
	},
	roleLabel: {
		color: '#666666',
		fontSize: 14,
	},
	roleButtons: {
		display: 'grid',
		gridTemplateColumns: '1fr 1fr',
		gap: 10,
		marginTop: 5,
	},
	roleBtn: {
		width: '100%',
		height: 40,
		borderRadius: 5,
		textTransform: 'none',
		border: '1px solid #E5E5EA',
		color: '#afafaf',
		background: '#fff',
		fontSize: 14,
		// 눌림/호버 때도 흰색 유지
		'&:hover': { background: '#fff' },
		'&:active': { background: '#fff' },
	},
	roleBtnActive: {
		background: COLORS.WATER_BLUE,
		color: '#fff',
		fontWeight: 700,
		borderColor: COLORS.WATER_BLUE,
		// 눌림/호버 때도 파랑 유지
		'&:hover': { background: COLORS.WATER_BLUE },
		'&:active': { background: COLORS.WATER_BLUE },
	},
	actionsRow: {
		display: 'grid',
		gridTemplateColumns: '1fr 1fr',
		gap: 10,
	},
	cancelBtn: {
		height: 40,
		borderRadius: 5,
		textTransform: 'none',
		fontWeight: 700,
		fontSize: 14,
		color: '#666666',
		border: '1px solid #767676',
	},
	submitPrimary: {
		height: 40,
		borderRadius: 5,
		textTransform: 'none',
		fontSize: 14,
		fontWeight: 700,
		background: COLORS.WATER_BLUE,
		color: '#fff',
		'&:disabled': {
			background: '#BFC7D0',
			color: 'white',
			border: '1px solid #BFC7D0',
		},
		'&:hover': {
			background: COLORS.WATER_BLUE,
		},
	},
	requiredDot: {
		color: '#FF6D6D',
		marginLeft: 4,
		fontSize: 14,
	},
	saleHint: {
		color: '#666666',
		fontSize: 13,
		textAlign: 'center',
		lineHeight: 1.45,
		fontFamily: 'NanumB',
	},
	salePriceValue: {
		color: COLORS.WATER_BLUE,
		fontWeight: 700,
		fontSize: 22,
		fontFamily: 'NanumB',
	},
	dialogMessage: {
		color: COLORS.CHARCOAL_GREY,
		fontSize: 16,
		textAlign: 'center',
		fontFamily: 'NanumB',
		fontWeight: 700,
		whiteSpace: 'pre-line',
		lineHeight: 1.55,
		padding: '12px 4px 4px',
	},
	dialogSubMessage: {
		color: '#666666',
		fontSize: 14,
		textAlign: 'center',
		fontFamily: 'NanumB',
		whiteSpace: 'pre-line',
		lineHeight: 1.45,
	},
	dialogInput: {
		backgroundColor: COLORS.LIGHT_GREY,
		width: '100%',
		height: 44,
		borderRadius: 8,
		fontSize: 16,
	},
	dialogList: {
		maxHeight: '28vh',
		overflowY: 'auto',
		width: '100%',
		border: '1px solid #E5E5EA',
		borderRadius: 8,
		background: '#F7F8FB',
		padding: '4px 10px',
	},
	actionsRowSingle: {
		display: 'grid',
		gridTemplateColumns: '1fr',
	},
	submitDanger: {
		height: 40,
		borderRadius: 5,
		textTransform: 'none',
		fontSize: 14,
		fontWeight: 700,
		background: COLORS.RED,
		color: '#fff',
		'&:disabled': {
			background: '#BFC7D0',
			color: 'white',
			border: '1px solid #BFC7D0',
		},
		'&:hover': {
			background: COLORS.RED,
		},
	},
	detailBtn: {
		textTransform: 'none',
		fontFamily: 'NanumB',
		fontWeight: 700,
		fontSize: 13,
		color: COLORS.WATER_BLUE,
		padding: 0,
		minWidth: 0,
	},
}));

const dialogPaperStyle = {
	borderRadius: 10,
	boxShadow: '3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
	backgroundColor: COLORS.WHITE,
	width: '80vw',
	maxWidth: 360,
};

const DialogShell: React.FC<any> = ({ open, onClose, title, children, ...dialogProps }) => {
	const classes = useStyles();
	return (
		<Dialog open={open} onClose={onClose} PaperProps={{ style: dialogPaperStyle }} classes={{ paper: classes.processRoot as any }} {...dialogProps}>
			<div className={classes.processHeader}>
				<Typography className={classes.processTitle}>{title}</Typography>
			</div>
			<div className={classes.processBody}>{children}</div>
		</Dialog>
	);
};

const DialogFooter: React.FC<any> = ({ alarm, onCancel, onConfirm, cancelText, confirmText, confirmTestId, confirmDisabled, cancelDisabled, danger }) => {
	const classes = useStyles();
	return (
		<div className={alarm === true ? classes.actionsRowSingle : classes.actionsRow}>
			{alarm !== true && (
				<Button className={classes.cancelBtn} onClick={onCancel} disabled={cancelDisabled}>
					{cancelText}
				</Button>
			)}
			<Button className={danger ? classes.submitDanger : classes.submitPrimary} onClick={onConfirm} data-testid={confirmTestId} disabled={confirmDisabled}>
				{confirmText}
			</Button>
		</div>
	);
};

const DialogConfirm: React.FC<any> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation('common');
	const hasContext = typeof props.context === 'string' ? props.context.trim() !== '' : Boolean(props.context);

	return (
		<DialogShell open={props.open} onClose={props.handleClose} title={props.title || t('common.yesText')}>
			{hasContext && <Typography className={classes.dialogMessage}>{props.context}</Typography>}
			<DialogFooter
				alarm={props.alarm}
				onCancel={props.noConfirm}
				onConfirm={props.yesConfirm}
				cancelText={props.noText || t('common.noText')}
				confirmText={props.yesText || t('common.yesText')}
				confirmTestId="dialog-confirm-yes-btn"
				confirmDisabled={props.confirmDisabled}
			/>
		</DialogShell>
	);
};

const DialogConfirm2: React.FC<any> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation(['common', 'student']);

	return (
		<DialogShell open={props.open} onClose={props.handleClose} title={props.title}>
			<Typography className={classes.dialogMessage}>
				{t('DialogConfirm2.title1')}
				<Typography className={classes.warnText}>{t('DialogConfirm2.title2')}</Typography>
				{t('DialogConfirm2.title3')}
			</Typography>
			{props.context && <Typography className={classes.dialogSubMessage}>{props.context}</Typography>}
			<DialogFooter
				onCancel={props.yesConfirm}
				onConfirm={props.handleMoveReceipt}
				cancelText={t('common.decline')}
				confirmText={t('DialogConfirm2.receiptText')}
			/>
		</DialogShell>
	);
};

const DialogConfirmDetail: React.FC<any> = (props) => {
	const classes = useStyles();
	const [detail, setDetail] = useState(false);
	const handleDetailButton = () => {
		setDetail((prevState: boolean) => !prevState);
	};
	const { t } = useTranslation('common');
	useEffect(() => {
		if (props.open) setDetail(false);
	}, [props.open]);
	return (
		<DialogShell open={props.open} onClose={props.handleClose} title={props.title}>
			<Typography className={classes.dialogMessage}>{detail === false ? props.context1 : props.context}</Typography>
			<Button className={classes.detailBtn} onClick={handleDetailButton}>
				{t('DialogConfirmDetail.detailText')}
			</Button>
			<DialogFooter
				alarm={props.alarm}
				onCancel={props.noConfirm}
				onConfirm={props.yesConfirm}
				cancelText={props.noText || t('common.noText')}
				confirmText={props.yesText || t('common.yesText')}
			/>
		</DialogShell>
	);
};

const DialogInputConfirm: React.FC<any> = (props) => {
	const classes = useStyles();
	const language = getSavedLanguage();
	const [input, setInput] = useState<number | undefined>(language === 'ko' ? props.price : props.price / 10);
	const [selectedCompany, setSelectedCompany] = useState<number>(0);
	const { t } = useTranslation(['common', 'student']);
	const defaultCompany = props.companyList?.length === 1 ? Number(props.companyList[0].company_num) : 0;
	const activeCompany = selectedCompany || defaultCompany;

	useEffect(() => {
		if (!props.open) return;
		setInput(language === 'ko' ? props.price : props.price / 10);
		setSelectedCompany(0);
	}, [props.open, props.price, language]);

	const handleRadioChange = (event: any) => {
		const selected = props.companyList.find((company: any) => company.company_num.toString() === event.target.value);
		console.log('selected? ', selected.company_num);
		setSelectedCompany(selected.company_num);
		//onCompanySelect(selected); // 부모 컴포넌트에 선택된 회사 전달
	};

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (e.target.value == '' || parseInt(e.target.value) >= 0) {
			setInput(parseInt(e.target.value));
		}
	};

	const confirm = (e: any) => {
		if (input !== undefined && input > 0 && activeCompany > 0) {
			if (language === 'ko') {
				props.yesConfirm(input, activeCompany);
			} else if (language === 'en') {
				props.yesConfirm(input * 10, activeCompany);
			}
		}
	};

	const handleNo = () => {
		props.noConfirm();
		setSelectedCompany(0);
	};

	return (
		<DialogShell open={props.open} onClose={handleNo} title={props.title}>
			{props.companyList && (
				<div className={classes.dialogList}>
					<RadioGroup value={activeCompany ? activeCompany.toString() : ''} onChange={handleRadioChange}>
						{props.companyList.map((item: any, index: number) => (
							<FormControlLabel
								data-testid={`dialog-input-select-company-radio-${item.company_name}`}
								style={{ color: 'black' }}
								key={index}
								value={item.company_num.toString()}
								control={<Radio style={{ color: COLORS.WATER_BLUE }} />}
								label={item.company_name}
							/>
						))}
					</RadioGroup>
				</div>
			)}
			{props.context && <Typography className={classes.dialogSubMessage}>{props.context}</Typography>}
			<InputBase
				className={classes.dialogInput}
				autoFocus
				margin="dense"
				type="number"
				value={input}
				onChange={handleChange}
				inputProps={{
					'aria-label': 'search google maps',
					style: { textAlign: 'center' },
					'data-testid': 'dialog-input-number',
				}}
			/>
			<DialogFooter
				alarm={props.alarm}
				onCancel={handleNo}
				onConfirm={confirm}
				cancelText={t('common.noText')}
				confirmText={t('common.yesText')}
				confirmTestId="dialog-input-confirm-yes-btn"
				confirmDisabled={!input || input <= 0 || activeCompany <= 0}
			/>
		</DialogShell>
	);
};

const DialogCompanyApproval: React.FC<any> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation(['common', 'student']);

	let variant: any;

	if (props.companyType == 'M') {
		variant = [
			{ value: '구매담당자', label: t('DialogCompanyApproval.purchase') },
			{ value: '판매담당자', label: t('DialogCompanyApproval.sale') },
			{ value: '생산담당자', label: t('DialogCompanyApproval.production') },
		];
	} else if (props.companyType == 'D') {
		variant = [
			{ value: '구매담당자', label: t('DialogCompanyApproval.purchase') },
			{ value: '판매담당자', label: t('DialogCompanyApproval.sale') },
			{ value: '분해담당자', label: t('DialogCompanyApproval.disassemble') },
		];
	} else if (props.companyType == 'S') {
		variant = [
			{ value: '구매담당자', label: t('DialogCompanyApproval.purchase') },
			{ value: '생산담당자', label: t('DialogCompanyApproval.disassemble') },
			{ value: '판매담당자', label: t('DialogCompanyApproval.sale') },
		];
	} else {
		variant = [
			{ value: '구매담당자', label: t('DialogCompanyApproval.purchase') },
			{ value: '판매담당자', label: t('DialogCompanyApproval.sale') },
			{ value: '생산담당자', label: t('DialogCompanyApproval.production') },
		];
	}

	const [grade, setGrade] = useState(variant[0]);

	useEffect(() => {
		if (!props.open) return;
		const initial = variant.find((v: any) => v.value === props.initialGrade) || variant[0];
		setGrade(initial);
	}, [props.open, props.initialGrade, props.companyType]);

	const onSelectChange = (e: any) => {
		setGrade(e);
	};

	const handleYes = () => {
		if (grade.label !== '') {
			props.yesConfirm(grade.value);
		}
	};

	return (
		<DialogShell open={props.open} onClose={props.handleClose} title={props.companyName}>
			<div className={classes.infoBox}>
				<div className={classes.infoRow}>
					<Typography className={classes.infoLabel}>
						{props.memberName} {t('DialogCompanyApproval.roleText')}
					</Typography>
					<Select
						isSearchable={false}
						value={grade}
						onChange={onSelectChange}
						defaultValue={variant[0]}
						options={variant}
						menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
						styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
					/>
				</div>
			</div>
			<DialogFooter
				onCancel={props.noConfirm}
				onConfirm={handleYes}
				cancelText={t('common.noText')}
				confirmText={t('common.yesText')}
			/>
		</DialogShell>
	);
};

const DialogSaleApproval: React.FC<any> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation(['common', 'student']);

	const handleYes = () => {
		props.yesConfirm();
	};

	return (
		<DialogShell open={props.open} onClose={props.handleClose} title={t('DialogSaleApproval.title')}>
			<div className={classes.infoBox}>
				<div className={classes.infoRow}>
					<Typography className={classes.infoLabel}>{t('DialogSaleApproval.companyLabel')}</Typography>
					<Typography className={classes.infoValue}>{props.companyName}</Typography>
				</div>
			</div>
			<Typography className={classes.dialogMessage}>{t('DialogSaleApproval.question')}</Typography>
			<DialogFooter onCancel={props.noConfirm} onConfirm={handleYes} cancelText={t('common.noText')} confirmText={t('common.yesText')} />
		</DialogShell>
	);
};

const DialogSaleApprovalPrice: React.FC<any> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation(['common', 'student']);

	const handleYes = () => {
		props.yesConfirm();
	};

	return (
		<DialogShell open={props.open} onClose={props.handleClose} title={t('DialogSaleApprovalPrice.title')}>
			<div className={classes.infoBox}>
				<div className={classes.infoRow}>
					<Typography className={classes.infoLabel}>{t('DialogSaleApprovalPrice.companyLabel')}</Typography>
					<Typography className={classes.infoValue}>{props.companyName}</Typography>
				</div>
				<div className={classes.infoRow}>
					<Typography className={classes.infoLabel}>{t('DialogSaleApprovalPrice.totalLabel')}</Typography>
					<Typography className={classes.salePriceValue}>{props.totalPrice}</Typography>
				</div>
			</div>
			<Typography className={classes.saleHint}>{t('DialogSaleApprovalPrice.desc')}</Typography>
			<DialogFooter
				onCancel={props.noConfirm}
				onConfirm={handleYes}
				cancelText={t('DialogSaleApprovalPrice.cancel')}
				confirmText={t('DialogSaleApprovalPrice.confirm')}
				confirmTestId="dialog-sale-approval-yes-btn"
			/>
		</DialogShell>
	);
};

const DialogInput: React.FC<any> = (props) => {
	const classes = useStyles();
	const [input, setInput] = useState<number | undefined>();
	const { t } = useTranslation(['common', 'student']);
	const language = getSavedLanguage();
	const { enqueueSnackbar } = useSnackbar();
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (e.target.value == '' || parseInt(e.target.value) >= 0) {
			setInput(parseInt(e.target.value));
		}
	};

	const confirm = (e: any) => {
		if (input !== undefined && input > 0) {
			if (language === 'ko') {
				props.yesConfirm(e, input);
			} else if (language === 'en') {
				props.yesConfirm(e, input * 10);
			}
		} else {
			enqueueSnackbar(ToastStr.COMPANY_ASSET_UPDATE_FAIL_STR, { variant: 'warning' });
		}
	};

	useEffect(() => {
		setInput(undefined);
	}, [props.open]);

	return (
		<DialogShell open={props.open} onClose={props.handleClose} title={props.title}>
			<InputBase
				className={classes.dialogInput}
				autoFocus
				margin="dense"
				type="number"
				value={input}
				onChange={handleChange}
				inputProps={{
					'aria-label': 'search google maps',
					style: { textAlign: 'center' },
					'data-testid': 'dialog-input-number',
				}}
			/>
			<DialogFooter
				onCancel={props.noConfirm}
				onConfirm={confirm}
				cancelText={t('common.noText')}
				confirmText={t('common.yesText')}
				confirmTestId="dialog-input-number-yes-btn"
			/>
		</DialogShell>
	);
};

const DialogInputText: React.FC<any> = (props) => {
	const classes = useStyles();
	const [input, setInput] = useState<string | undefined>();
	const { t } = useTranslation(['common', 'student']);

	useEffect(() => {
		if (props.open) setInput(undefined);
	}, [props.open]);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setInput(e.target.value);
	};

	const confirm = (e: any) => {
		if (input !== undefined) {
			props.yesConfirm(e, input);
		}
	};

	return (
		<DialogShell open={props.open} onClose={props.handleClose} title={props.title}>
			<InputBase
				className={classes.dialogInput}
				autoFocus
				margin="dense"
				type="text"
				value={input}
				onChange={handleChange}
				inputProps={{
					'aria-label': 'search google maps',
					style: { textAlign: 'center' },
					'data-testid': 'dialog-input-text-input',
				}}
			/>
			<DialogFooter
				onCancel={props.noConfirm}
				onConfirm={confirm}
				cancelText={t('common.noText')}
				confirmText={t('common.yesText')}
				confirmTestId="dialog-input-text-yes-btn"
			/>
		</DialogShell>
	);
};

const DialogInputText2: React.FC<any> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation(['common', 'student']);
	const [input, setInput] = useState<string | undefined>();

	useEffect(() => {
		if (props.open) setInput(undefined);
	}, [props.open]);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setInput(e.target.value);
	};

	const confirm = (e: any) => {
		if (input !== undefined) {
			props.yesConfirm(e, input);
		}
	};

	return (
		<DialogShell open={props.open} onClose={props.handleClose} title={props.title}>
			<InputBase
				className={classes.dialogInput}
				autoFocus
				margin="dense"
				type="text"
				value={input}
				onChange={handleChange}
				inputProps={{
					'aria-label': 'search google maps',
					style: { textAlign: 'center' },
				}}
			/>
			<DialogFooter onCancel={props.noConfirm} onConfirm={confirm} cancelText={t('common.noText')} confirmText={t('common.yesText')} />
		</DialogShell>
	);
};

const DialogDeleteClass: React.FC<any> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation(['common', 'student']);
	return (
		<DialogShell open={props.open} onClose={props.handleClose} title={props.title}>
			{props.context && <Typography className={classes.dialogMessage}>{props.context}</Typography>}
			<DialogFooter
				alarm={props.alarm}
				onCancel={props.noConfirm}
				onConfirm={props.yesConfirm}
				cancelText={t('common.noText')}
				confirmText={t('common.yesText')}
				danger
			/>
		</DialogShell>
	);
};

const DialogApprove: React.FC<any> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation(['common', 'student']);
	return (
		<DialogShell open={props.open} onClose={props.handleClose} title={props.title}>
			{props.context && <Typography className={classes.dialogMessage}>{props.context}</Typography>}
			<DialogFooter
				alarm={props.alarm}
				onCancel={props.noConfirm}
				onConfirm={props.yesConfirm}
				cancelText={t('common.noText')}
				confirmText={t('common.yesText')}
			/>
		</DialogShell>
	);
};

const DialogPopup: React.FC<any> = (props) => {
	const classes = useStyles();
	return (
		<DialogShell open={props.open} onClose={props.handleClose} title={props.title}>
			{props.context && <Typography className={classes.dialogMessage}>{props.context}</Typography>}
		</DialogShell>
	);
};

const DialogDeleteCompany: React.FC<any> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation(['common', 'student']);
	const [clicked, setClicked] = useState(false);
	const members = props.context;

	const handleSafeClose = (_event?: any, reason?: string) => {
		if (clicked) return;
		if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
		props.handleClose();
	};

	const yesConfirm = (event?: any) => {
		if (event?.preventDefault) event.preventDefault();
		if (event?.stopPropagation) event.stopPropagation();
		if (clicked) return;
		setClicked(true);
		props.yesConfirm();
		props.handleClose();
	};
	const noConfirm = (event?: any) => {
		if (event?.preventDefault) event.preventDefault();
		if (event?.stopPropagation) event.stopPropagation();
		if (clicked) return;
		props.noConfirm();
	};
	return (
		<DialogShell
			open={props.open}
			onClose={handleSafeClose}
			title={props.title}
			disableEscapeKeyDown={clicked}
			onMouseDown={(event: any) => event.stopPropagation()}
			onClick={(event: any) => event.stopPropagation()}
		>
			<div className={classes.infoBox}>
				<Typography className={classes.infoLabel}>{t('DialogDeleteCompany.inThisCompany')}</Typography>
				{members &&
					members.map((member: any, index: number) => (
						<Typography key={index} className={classes.infoValue}>
							{t('DialogDeleteCompany.nameLabel')} {member.member_name}
						</Typography>
					))}
				<Typography className={classes.infoValue}>
					{t('DialogDeleteCompany.totalMembersPrefix')} {members ? members.length : 0} {t('DialogDeleteCompany.totalMembersSuffix')}
				</Typography>
			</div>
			<Typography className={classes.saleHint} style={{ color: COLORS.RED, fontWeight: 700 }}>
				{t('DialogDeleteCompany.warning')}
			</Typography>
			<DialogFooter
				alarm={props.alarm}
				onCancel={noConfirm}
				onConfirm={yesConfirm}
				cancelText={t('common.noText')}
				confirmText={t('common.yesText')}
				confirmTestId="dialog-delete-company-yes-btn"
				confirmDisabled={clicked}
				cancelDisabled={clicked}
				danger
			/>
		</DialogShell>
	);
};

const DialogSelectCompany: React.FC<any> = (props) => {
	const classes = useStyles();
	const [selectedCompany, setSelectedCompany] = useState<number>(0);
	const { t } = useTranslation(['common', 'student']);

	const defaultCompany = props.companyList?.length === 1 ? props.companyList[0].company_num : 0;
	const activeCompany = selectedCompany || defaultCompany;

	useEffect(() => {
		if (props.open) setSelectedCompany(0);
	}, [props.open, props.companyList]);

	const handleRadioChange = (event: any) => {
		const selected = props.companyList.find((company: any) => company.company_num.toString() === event.target.value);
		console.log('selected? ', selected.company_num);
		setSelectedCompany(selected.company_num);
		//onCompanySelect(selected); // 부모 컴포넌트에 선택된 회사 전달
	};

	const handleYes = () => {
		props.yesConfirm(activeCompany);
	};

	const handleNo = () => {
		props.noConfirm();
		setSelectedCompany(0);
	};

	return (
		<DialogShell open={props.open} onClose={handleNo} title={props.title}>
			{props.companyList && (
				<div className={classes.dialogList}>
					<RadioGroup value={activeCompany ? activeCompany.toString() : ''} onChange={handleRadioChange}>
						{props.companyList.map((item: any, index: number) => (
							<FormControlLabel
								data-testid={`dialog-select-company-radio-${item.company_name}`}
								style={{ color: 'black' }}
								key={index}
								value={item.company_num.toString()}
								control={<Radio style={{ color: COLORS.WATER_BLUE }} />}
								label={item.company_name}
							/>
						))}
					</RadioGroup>
				</div>
			)}
			{props.context && <Typography className={classes.dialogMessage}>{props.context}</Typography>}
			<DialogFooter
				alarm={props.alarm}
				onCancel={handleNo}
				onConfirm={handleYes}
				cancelText={t('common.noText')}
				confirmText={t('common.yesText')}
				confirmTestId="dialog-select-company-submit-btn"
				confirmDisabled={activeCompany <= 0}
			/>
		</DialogShell>
	);
};

const DialogCompanyProcess: React.FC<any> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation(['common', 'student']);
	const { open, onClose, companyName, ceoName, companyType, defaultRole, onSubmit } = props;

	const [role, setRole] = React.useState<string | null>(null);

	useEffect(() => {
		if (open) setRole(null);
	}, [open, companyName, defaultRole]);

	const submit = () => {
		if (defaultRole === 'leader') {
			onSubmit();
		}
		if (defaultRole === 'member') {
			if (!role) return;
			onSubmit(role);
		}
	};

	const cancel = () => {
		onClose();
	};

	return (
		<DialogShell open={open} onClose={onClose} title={defaultRole === 'leader' ? t('DialogCompanyProcess.headerCreate') : t('DialogCompanyProcess.headerApply')}>
			<div className={classes.infoBox}>
				<div className={classes.infoRow}>
					<Typography className={classes.infoLabel}>{t('DialogCompanyProcess.labelCompanyName')}</Typography>
					<Typography className={classes.infoValue}>{companyName}</Typography>
				</div>
				<div className={classes.infoRow}>
					<Typography className={classes.infoLabel}>{t('DialogCompanyProcess.labelCeo')}</Typography>
					<Typography className={classes.infoValue}>{ceoName}</Typography>
				</div>
				<div className={classes.infoRow}>
					<Typography className={classes.infoLabel}>{t('DialogCompanyProcess.labelCompanyType')}</Typography>
					<Typography className={classes.infoValue}>
						{companyType === 'M' || companyType === 'm'
							? t('DialogCompanyProcess.typeManufacture')
							: companyType === 'D' || companyType === 'd'
								? t('DialogCompanyProcess.typeDistribution')
								: t('DialogCompanyProcess.typeOther')}
					</Typography>
				</div>
			</div>

			{defaultRole === 'member' && (
				<>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<Typography className={classes.roleLabel}>{t('DialogCompanyProcess.labelApplyRole')}</Typography>
						<Typography className={classes.requiredDot}>*</Typography>
					</div>
					<div className={classes.roleButtons}>
						<Button
							className={`${classes.roleBtn} ${role === '구매담당자' ? classes.roleBtnActive : ''}`}
							onClick={() => setRole('구매담당자')}
							data-testid="company-role-purchase-btn"
						>
							{t('DialogCompanyProcess.rolePurchase')}
						</Button>
						<Button className={`${classes.roleBtn} ${role === '판매담당자' ? classes.roleBtnActive : ''}`} onClick={() => setRole('판매담당자')} data-testid="company-role-sales-btn">
							{t('DialogCompanyProcess.roleSales')}
						</Button>
						{companyType === 'M' && (
							<Button
								className={`${classes.roleBtn} ${role === '생산담당자' ? classes.roleBtnActive : ''}`}
								onClick={() => setRole('생산담당자')}
								data-testid="company-role-production-btn"
							>
								{t('DialogCompanyProcess.roleProduction')}
							</Button>
						)}
						{companyType === 'D' && (
							<Button
								className={`${classes.roleBtn} ${role === '분해담당자' ? classes.roleBtnActive : ''}`}
								onClick={() => setRole('분해담당자')}
								data-testid="company-role-disassemble-btn"
							>
								{t('DialogCompanyProcess.roleDisassemble')}
							</Button>
						)}
					</div>
				</>
			)}

			<DialogFooter
				onCancel={cancel}
				onConfirm={submit}
				cancelText={t('DialogCompanyProcess.cancel')}
				confirmText={defaultRole === 'leader' ? t('DialogCompanyProcess.submitCreate') : t('DialogCompanyProcess.submitApply')}
				confirmTestId="company-dialog-confirm-btn"
				confirmDisabled={defaultRole === 'member' ? !role : false}
			/>
		</DialogShell>
	);
};

const DialogEditCEODialog: React.FC<any> = (props) => {
	const classes = useStyles();
	const [selectedCEO, setSelectedCEO] = useState<string>('');
	const { t } = useTranslation('common');
	const selectableMembers = (props.memberList ?? []).filter((item: any) => item.grade !== 'CEO');

	useEffect(() => {
		if (props.open) setSelectedCEO('');
	}, [props.open, props.memberList]);

	const handleRadioChange = (event: any) => {
		setSelectedCEO(event.target.value);
	};

	const handleYes = () => {
		props.yesConfirm(selectedCEO);
	};

	const handleNo = () => {
		props.noConfirm();
		setSelectedCEO('');
	};

	return (
		<DialogShell open={props.open} onClose={handleNo} title={props.title}>
			{selectableMembers.length > 0 ? (
				<div className={classes.dialogList}>
					<RadioGroup onChange={handleRadioChange}>
						{selectableMembers.map((item: any, index: number) => (
							<FormControlLabel
								data-testid={`dialog-select-ceo-radio-${item.member_name}`}
								style={{ color: 'black' }}
								key={index}
								value={item.member_email}
								control={<Radio style={{ color: COLORS.WATER_BLUE }} />}
								label={item.member_name}
							/>
						))}
					</RadioGroup>
				</div>
			) : (
				<Typography className={classes.dialogMessage} data-testid="dialog-select-ceo-empty">
					{props.emptyText}
				</Typography>
			)}
			<DialogFooter
				alarm={props.alarm}
				onCancel={handleNo}
				onConfirm={handleYes}
				cancelText={t('common.noText')}
				confirmText={t('common.yesText')}
				confirmTestId="dialog-select-ceo-submit-btn"
				confirmDisabled={!selectedCEO}
			/>
		</DialogShell>
	);
};

export default DialogConfirm;
export {
	DialogConfirm,
	DialogConfirm2,
	DialogConfirmDetail,
	DialogInputConfirm,
	DialogCompanyApproval,
	DialogSaleApproval,
	DialogInput,
	DialogInputText,
	DialogDeleteClass,
	DialogApprove,
	DialogSaleApprovalPrice,
	DialogPopup,
	DialogInputText2,
	DialogDeleteCompany,
	DialogSelectCompany,
	DialogCompanyProcess,
	DialogEditCEODialog,
};
